/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunicationTypeDto } from '../../models/communication-type-dto';

export interface GetAllCommunicationTypes$Params {
}

export function getAllCommunicationTypes(http: HttpClient, rootUrl: string, params?: GetAllCommunicationTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommunicationTypeDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllCommunicationTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CommunicationTypeDto>>;
    })
  );
}

getAllCommunicationTypes.PATH = '/communications/types';
